export default __webpack_public_path__ + "static/media/fwo_logo.996e304d.png";